export default "__VITE_ASSET__DWYxHjQL__"